// Adopted from youtube-embed-video npm package
import React from 'react';
import PropTypes from 'prop-types';

function getFullVideoUrl(
  videoId: string,
  autoplay: boolean,
  enhancedPrivacy: boolean,
  suggestions: boolean,
  controls: boolean,
  showInfo: boolean,
): string {
  const params: string[] = [];

  if (enhancedPrivacy) params.push('https://www.youtube-nocookie.com/embed/');
  else params.push('https://www.youtube.com/embed/');

  params.push(videoId);
  params.push(autoplay ? '?autoplay=1' : '?autoplay=0');

  if (!suggestions) params.push('&rel=0');

  if (!controls) params.push('&controls=0');

  if (!showInfo) params.push('&showinfo=0');

  return params.join('');
}

function getVideoId(url): string | null {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(shorts\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : null;
}

const checkVideoUrl = (props, propName, componentName) => {
  if (!props.videoId && !props[propName]) {
    return new Error('Please provide at least a videoUrl or videoId');
  }
};

const checkVideoId = (props, propName, componentName) => {
  if (!props.videoUrl && !props[propName]) {
    return new Error('Please provide at least a videoUrl or videoId');
  }
};

function YoutubeEmbedVideo(props) {
  let videoId = props.videoId;
  const {
    videoUrl,
    autoplay,
    suggestions,
    controls,
    showInfo,
    enhancedPrivacy,
    width,
    height,
    style,
    ...rest
  } = props;

  videoId = !videoId && videoUrl ? getVideoId(videoUrl) : '';
  const url = getFullVideoUrl(
    videoId,
    autoplay,
    enhancedPrivacy,
    suggestions,
    controls,
    showInfo,
  );
  return (
    <iframe
      width={width}
      height={height}
      style={style}
      src={url}
      frameBorder="0"
      allowFullScreen={true}
      title="Youtube Embed Video"
      {...rest}
    />
  );
}

YoutubeEmbedVideo.propTypes = {
  videoId: checkVideoId,
  videoUrl: checkVideoUrl,
  width: PropTypes.number,
  height: PropTypes.number,
  autoplay: PropTypes.bool,
  enhancedPrivacy: PropTypes.bool,
  suggestions: PropTypes.bool,
  controls: PropTypes.bool,
  showInfo: PropTypes.bool,
};

export default YoutubeEmbedVideo;
